import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as util from 'lib/utility';
import * as actions from 'state/modules/assign';
import { clone } from 'lodash';
import styles from './PopupSubmitInspection.css';

const debug = _debug('app:PopupSubmitInspection');
class PopupSubmitInspection extends Component {
  static propTypes = {
    closeModal: React.PropTypes.func,
    wholeData: React.PropTypes.shape({}),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsData: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    updateInspectionsDisposition: React.PropTypes.func,
    ownerId: React.PropTypes.string
  };

  constructor(props) {
    debug(props);
    super(props);
    this.state = { value: '' };
  }

  componentWillMount() {
    const wholeData = this.props.wholeData;
    debug('wholeData', wholeData);
  }

  submitInspectionData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    const dataToUpdate = [{ suppressDuplicateErrors: 1, updates: [] }];
    const ownerId = this.props.ownerId;
    console.log('ownerId==>', ownerId);
    const dataDict = {
      action: 'U',
      fields: {},
      modelName: 'cica_inspections',
      modelId: dataId
    };
    let correctData = {};
    // const submitData = {};
    this.props.inspectionsDataAll.forEach((data) => {
      if (data.id.indexOf(dataId) > -1) {
        correctData = clone(data);
        correctData.cica_issubmitted = 1; // eslint-disable-line
        dataDict.fields.cica_issubmitted = true; // eslint-disable-line
        dataDict.fields.cica_trainingopportunitystr =
          (correctData.cica_trainingopportunity).toString();
        dataDict.fields.cica_customerexperience = correctData.cica_customerexperience;
        dataDict.fields.cica_comments =
        correctData.cica_comments ? correctData.cica_comments : null;
        dataDict.fields.cica_disposition = 1;
        dataDict.fields.cica_couldnotcntowner = null;
        dataDict.fields.cica_isduplicate = false;
        dataToUpdate[0].updates.push(dataDict);
      }
    });
    console.log('dataToUpdate==>', dataToUpdate);
    this.props.updateInspectionsData(correctData);
    const assignmentCompleteCB = () => {
      this.props.closeModal(true);
    };
    this.props.updateInspectionsDisposition(dataToUpdate, ownerId)
    .then(assignmentCompleteCB)
    .catch((error) => {
      debug(error);
    });
  }

  render() {
    const { strings, wholeData } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.popupText}>
          <div className={styles.boldLabelText}>
            {strings.submitreviewtext}
          </div>
          <div className={styles.labelText}>
            <span className={styles.underlineText}>{strings.payment}</span>
            <span>{strings.submitpaymenttext}</span>
          </div>
          <div className={styles.labelText}>
            <span className={styles.underlineText}>{strings.customerexperience}</span>
            <span>{util.getCustomerExperience(wholeData.cica_customerexperience, strings)}</span>
          </div>
          <div className={styles.labelText}>
            <span className={styles.underlineText}>{strings.trainingopportunity}</span>
            <div className={styles.trainingopportunity}>
              {wholeData.cica_trainingopportunity &&
                wholeData.cica_trainingopportunity.map((item, index) => {
                  if (index === 0) {
                    return (
                      <div className={styles.labelTextItem}>
                        <span>{util.getTrainingOpportunity(item, strings)}</span>
                      </div>);
                  }
                  return (
                    <div className={styles.labelTextItem}>
                      <span>{util.getTrainingOpportunity(item, strings)}</span>
                    </div>
                  );
                })
              }
            </div>
          </div>
          <div className={styles.labelText}>
            <span className={styles.underlineText}>{strings.comments}</span>
            <span className={styles.comments}>{wholeData.cica_comments}</span>
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.submitInspectionData()}
            >{strings.submit}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closeModal()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(PopupSubmitInspection);



// WEBPACK FOOTER //
// ./src/components/PopupSubmitInspection/PopupSubmitInspection.js